import TrianglePath from './parts/TrianglePath'
import { FC, useId } from 'react'
import { View } from 'react-native'
import Svg, { Pattern, Rect } from 'react-native-svg'

const triangleSize = 10

const Cutout: FC = () => {
    const id = useId()

    return (
        <View style={{ height: triangleSize }}>
            <Svg>
                <Pattern
                    id={id}
                    patternUnits="userSpaceOnUse"
                    width={triangleSize * 2}
                    height={triangleSize}
                >
                    <TrianglePath />
                    <TrianglePath transform={`rotate(90 ${triangleSize} ${triangleSize})`} />
                </Pattern>
                <Rect width="100%" height="100%" fill={`url(#${id})`} />
            </Svg>
        </View>
    )
}

export default Cutout
